import { RotateLeft } from "@mui/icons-material";
import { Chip } from "@mui/material";
import __ from "src/utils/Translations";
import { useQuerySalaryDeductionDocument } from "src/Pages/Company/Pending/PendingBenefits/query";

export const SalaryDeductionDocument = ({ groupId }: { groupId: string }) => {
  const { isFetching } = useQuerySalaryDeductionDocument(groupId);

  return (
    <Chip
      icon={
        <RotateLeft
          aria-hidden="true"
          sx={
            isFetching
              ? {
                  animation: "spin 1.2s linear infinite",
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(0deg)",
                    },
                    "100%": {
                      transform: "rotate(-360deg)",
                    },
                  },
                }
              : {}
          }
        />
      }
      label={__("Generowanie zgody na potrącenie")}
      color="default"
      size="small"
      variant="outlined"
      sx={{
        bgcolor: "white",
      }}
    />
  );
};
